const severityPriority = {
  critical: 4,
  serious: 3,
  moderate: 2,
  minor: 1,
  'n/a': 0,
  undefined: 0,
};

const severityLabels = {
  critical: 'Crítico',
  serious: 'Grave',
  moderate: 'Moderado',
  minor: 'Baixo',
  'n/a': 'Não informado',
  unknown: 'Não informado',
};

const severityOrder = ['critical', 'serious', 'moderate', 'minor'];

const getSeverityKey = (impact) => {
  if (!impact) return 'unknown';
  const normalized = String(impact).toLowerCase();
  if (normalized === 'n/a' || normalized === 'na') {
    return 'unknown';
  }
  if (severityLabels[normalized] && normalized !== 'unknown') {
    return normalized;
  }
  return 'unknown';
};

const getSeverityLabel = (impact) => {
  const key = getSeverityKey(impact);
  return severityLabels[key] || severityLabels.unknown;
};

export {
  getSeverityKey,
  getSeverityLabel,
  severityLabels,
  severityOrder,
  severityPriority,
};
